import { SubtitlesDevice, SubtitlesPositions, SubtitlesSize, SubtitlesTextSize, SubtitlesViewport } from './types';

export const SUBTITLES_DEFAULT_POSITIONS: SubtitlesPositions = {
  [SubtitlesViewport.DESKTOP]: {
    x: 0.5, // center horizontally (960 / 1920)
    y: 0.5, // center vertically (540 / 1080)
  },
  [SubtitlesViewport.LANDSCAPE]: {
    x: 0.5, //  center horizontally (center of 667px width)
    y: 0.17, // 17% from container's top
  },
  [SubtitlesViewport.PORTRAIT]: {
    x: 0.5, // center horizontally (center of 375px width)
    y: 0.12, // 12% from container's top edge
  },
};

export const SUBTITLES_DEFAULT_SIZES: SubtitlesSize = {
  [SubtitlesDevice.DESKTOP]: SubtitlesTextSize.LARGE,
  [SubtitlesDevice.MOBILE]: SubtitlesTextSize.MEDIUM,
};

// Subtitles languages supported by translation service.
export const SUBTITLES_SUPPORTED_LANGUAGES = [
  'af',
  'am',
  'ar',
  'as',
  'az',
  'ba',
  'bg',
  'bho',
  'bn',
  'bo',
  'brx',
  'bs',
  'ca',
  'cs',
  'cy',
  'da',
  'de',
  'doi',
  'dsb',
  'dv',
  'el',
  'en',
  'es',
  'et',
  'eu',
  'fa',
  'fi',
  'fil',
  'fj',
  'fo',
  'fr',
  'fr-CA',
  'ga',
  'gl',
  'gom',
  'gu',
  'ha',
  'he',
  'hi',
  'hne',
  'hr',
  'hsb',
  'ht',
  'hu',
  'hy',
  'id',
  'ig',
  'ikt',
  'is',
  'it',
  'iu',
  'iu-Latn',
  'ja',
  'ka',
  'kk',
  'km',
  'kmr',
  'kn',
  'ko',
  'ks',
  'ku',
  'ky',
  'ln',
  'lo',
  'lt',
  'lug',
  'lv',
  'lzh',
  'mai',
  'mg',
  'mi',
  'mk',
  'ml',
  'mn-Cyrl',
  'mn-Mong',
  'mni',
  'mr',
  'ms',
  'mt',
  'mww',
  'my',
  'nb',
  'ne',
  'nl',
  'nso',
  'nya',
  'or',
  'otq',
  'pa',
  'pl',
  'prs',
  'ps',
  'pt',
  'pt-PT',
  'ro',
  'ru',
  'run',
  'rw',
  'sd',
  'si',
  'sk',
  'sl',
  'sm',
  'sn',
  'so',
  'sq',
  'sr-Cyrl',
  'sr-Latn',
  'st',
  'sv',
  'sw',
  'ta',
  'te',
  'th',
  'ti',
  'tk',
  'tlh-Latn',
  'tlh-Piqd',
  'tn',
  'to',
  'tr',
  'tt',
  'ty',
  'ug',
  'uk',
  'ur',
  'uz',
  'vi',
  'xh',
  'yo',
  'yua',
  'yue',
  'zh-Hans',
  'zh-Hant',
  'zu',
];

export const ONBOARDING_DURATION = 3000;
